import { render } from "./CardsGame.vue?vue&type=template&id=d0f0a620&scoped=true"
import script from "./CardsGame.vue?vue&type=script&lang=js"
export * from "./CardsGame.vue?vue&type=script&lang=js"

import "./CardsGame.vue?vue&type=style&index=0&id=d0f0a620&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f0a620"]])

export default __exports__